import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f57d6860"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Já Pensou em ter uma conta digital? ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Entre na nossa lista de espera ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" E seja um dos primeiros a ter essa ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "novidade", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("OK")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Dados do cartão virtual ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Cartão Virtual ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Código verificador ")
const _hoisted_9 = { class: "card-texts" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Senha", -1))
const _hoisted_11 = { class: "card-texts" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Validade", -1))
const _hoisted_13 = { class: "card-texts" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "100",
  src: "/assets/img/assets_images_logocard.png"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("OK")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Digite os ")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "4 últimos", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" digitos do seu cartão")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Jaú Serve ")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Área dos Colaboradores ")
const _hoisted_26 = { class: "font-montserrat font-30" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = { class: "font-montserrat font-15 gray" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Limite total: ")
const _hoisted_30 = { class: "limite-valor" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "font-montserrat font-11 minheight" }
const _hoisted_34 = { class: "font-montserrat font-25" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = { class: "font-montserrat font-15 gray" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Limite total: ")
const _hoisted_38 = { class: "limite-valor" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Gerar Cartão Virtual ")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Área de Colaboradores ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "100",
  src: "/assets/img/assets_images_logocard.png"
}, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Histórico de Transações ")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Nenhuma transação encontrada ", -1))
const _hoisted_49 = { class: "descricao" }
const _hoisted_50 = { class: "font-poppins bold total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_loading, { "is-open": _ctx.isOpenLoading }, null, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "is-open": _ctx.isOpenListaEspera,
        "initial-breakpoint": 0.70,
        breakpoints: [0.80]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "b2",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "b3",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenAtivacao=false)),
                        size: "large",
                        shape: "jau",
                        color: "jauservelayoutalter"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "backdrop-dismiss": true,
        "is-open": _ctx.isOpenVirtual,
        "initial-breakpoint": 0.95,
        breakpoints: [0.95]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenVirtual=false)),
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_row, { class: "ion-align-items-center card-virtual" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "12",
                        class: "card-num"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.formatCardNumber(_ctx.cartao_virtual.cartao)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.cartao_virtual.cvv), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "4",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_10,
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.cartao_virtual.senha), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        size: "5",
                        class: "ion-text-center"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12,
                          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.cartao_virtual.validade), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "3" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center b1",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenVirtual=false)),
                        size: "large",
                        shape: "jau",
                        color: "jauservelayoutalter"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "backdrop-dismiss": true,
        onDidDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenNumCartao=false)),
        "is-open": _ctx.isOpenNumCartao,
        "initial-breakpoint": 0.95,
        breakpoints: [0.95]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.voltar();_ctx.isOpenNumCartao=false}),
                    class: "ion-text-center",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-start font-montserrat font-20",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center font-montserrat font-30",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_otp_input, {
                        ref: "otpInput",
                        "input-classes": 'input-cadastro',
                        separator: "       ",
                        "num-inputs": 4,
                        "should-auto-focus": false,
                        "is-input-num": true,
                        onOnComplete: _ctx.getContaVoucher,
                        placeholder: ['*', '*', '*', '*']
                      }, null, 8, ["onOnComplete"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[5] || (_cache[5] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { size: "12" }, {
            default: _withCtx(() => [
              (_ctx.tipo_menu==1)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    class: "font-montserrat-bold font-25 red",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_col, {
                class: "font-montserrat-bold font-30",
                size: "12"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Saldo Disponível " + _toDisplayString(_ctx.tipo_menu == 0 ? "Cashback" : "Voucher"), 1)
                ]),
                _: 1
              }),
              (_ctx.tipo_menu==1)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    class: "font-montserrat-bold font-15",
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cartão " + _toDisplayString(_ctx.numCard), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 2,
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_spinner, { name: "dots" })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_col, {
                    key: 3,
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          (_ctx.conta_digital.saldos.length == 0)
                            ? (_openBlock(), _createBlock(_component_ion_col, {
                                key: 0,
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$cart.currencyUSD(_ctx.conta_digital.saldo)), 1),
                                  _hoisted_27,
                                  _createElementVNode("div", _hoisted_28, [
                                    _hoisted_29,
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$cart.currencyUSD(_ctx.conta_digital.limite)), 1),
                                    _hoisted_31,
                                    _hoisted_32
                                  ])
                                ]),
                                _: 1
                              }))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.conta_digital.saldos, (saldo, index) => {
                                return (_openBlock(), _createBlock(_component_ion_col, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(saldo.Descricao), 1),
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$cart.currencyUSD(saldo.Valor)), 1),
                                    _hoisted_35,
                                    _createElementVNode("div", _hoisted_36, [
                                      _hoisted_37,
                                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$cart.currencyUSD(saldo.Limite)), 1),
                                      _hoisted_39,
                                      _hoisted_40
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 256))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          (_ctx.tipo_menu==0)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-align-items-center bg_white"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.gerarVirtual({cashback:true}))),
                        disabled: _ctx.conta_digital.saldo==0,
                        class: "ion-text-center ic-1"
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "ion-icon",
                          slot: "center",
                          icon: _ctx.card
                        }, null, 8, ["icon"]),
                        _hoisted_42,
                        _hoisted_43
                      ], 8, _hoisted_41)
                    ]),
                    _: 1
                  }),
                  (_ctx.tipo_menu==0)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        size: "6"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getVoucher())),
                            class: "ion-text-center ic-2"
                          }, [
                            _createVNode(_component_ion_icon, {
                              class: "ion-icon",
                              slot: "center",
                              icon: _ctx.card
                            }, null, 8, ["icon"]),
                            _hoisted_44,
                            _hoisted_45
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.tipo_menu==1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.cartoes, (cartao, index) => {
                return (_openBlock(), _createBlock(_component_ion_row, {
                  onClick: ($event: any) => (_ctx.showOpcao(cartao.nrCartao)),
                  class: "ion-align-items-center card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cartao.nmBandeira), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" XXXX-XXXX-XXXX-" + _toDisplayString(cartao.finalCartao), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_col, { size: "12" }, {
                      default: _withCtx(() => [
                        _hoisted_46
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 256))
            : _createCommentVNode("", true),
          _createVNode(_component_ion_list, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list_header, null, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }),
              (_ctx.conta_digital.extrato.length == 0)
                ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _hoisted_48
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conta_digital.extrato, (extrato, index) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  class: "ion-align-items-center",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_note, {
                      slot: "start",
                      color: "danger"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.toDia(extrato.data)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.toMese(extrato.data)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_label, { class: "ion-align-items-center" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(extrato.movimento) + " ", 1),
                        _createElementVNode("h2", _hoisted_49, _toDisplayString(extrato.description), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_ion_note, {
                      class: "ion-align-items-center",
                      slot: "end",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$cart.currencyUSD(extrato.valor)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}